/**
 * อ่านค่า Firebase config จาก environment
 *
 * ล้มทันทีตอนโหลดถ้าค่าไหนหาย — ดีกว่าปล่อยให้ SDK ไปพังตอน user กด login
 * ซึ่งจะได้ error ที่อ่านไม่รู้เรื่องแทน
 */
function required(name: string, value: string | undefined): string {
  if (value === undefined || value === '') {
    throw new Error(
      `ขาด environment variable "${name}" — คัดลอก web/.env.example เป็น web/.env แล้วใส่ค่าจริง`,
    );
  }
  return value;
}

export const firebaseConfig = {
  apiKey: required('VITE_FIREBASE_API_KEY', import.meta.env.VITE_FIREBASE_API_KEY),
  authDomain: required('VITE_FIREBASE_AUTH_DOMAIN', import.meta.env.VITE_FIREBASE_AUTH_DOMAIN),
  projectId: required('VITE_FIREBASE_PROJECT_ID', import.meta.env.VITE_FIREBASE_PROJECT_ID),
  storageBucket: required(
    'VITE_FIREBASE_STORAGE_BUCKET',
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  ),
  messagingSenderId: required(
    'VITE_FIREBASE_MESSAGING_SENDER_ID',
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  ),
  appId: required('VITE_FIREBASE_APP_ID', import.meta.env.VITE_FIREBASE_APP_ID),
} as const;

/** ต่อกับ emulator แทน Firebase จริงหรือไม่ */
export const useEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';

/**
 * host ของ emulator — ใช้ hostname เดียวกับที่หน้าเว็บถูกเสิร์ฟมา
 *
 * ห้าม hardcode เป็น `127.0.0.1` เพราะเบราว์เซอร์ถือว่า `localhost` กับ `127.0.0.1`
 * เป็นคนละ origin กัน ถ้าหน้าเว็บอยู่ `localhost:5173` แต่ Auth emulator อยู่ `127.0.0.1:9099`
 * การรับส่ง event ระหว่าง popup กับหน้าหลักของ `signInWithPopup` จะพังด้วย
 * `Auth Emulator Internal Error: No matching frame`
 *
 * ผูกกับ `location.hostname` ทำให้เปิดจาก localhost, 127.0.0.1 หรือ IP ในวง LAN
 * (ทดสอบบนมือถือ) ก็ตรงกันเสมอโดยไม่ต้องแก้โค้ด
 */
export const EMULATOR_HOST = globalThis.location?.hostname || '127.0.0.1';
export const AUTH_EMULATOR_PORT = 9099;
export const FIRESTORE_EMULATOR_PORT = 8080;
export const FUNCTIONS_EMULATOR_PORT = 5001;

/**
 * ต้องตรงกับ `FUNCTIONS_REGION` ใน `functions/src/region.ts` — spec Section 3.1
 *
 * ⚠️ **ไม่ใช่** `asia-southeast3` ที่ Firestore อยู่ — Cloud Functions ไม่รองรับ Bangkok
 * ถ้าค่านี้ไม่ตรงกับที่ deploy จริง การเรียก callable จะได้ 404 โดยไม่บอกสาเหตุ
 */
export const FUNCTIONS_REGION = 'asia-southeast1';
